module.exports = __webpack_public_path__ + "img/39_43.40b00094.png";